import React, { useState } from 'react';
import Layout from '../../Components/Layout.jsx';
import { 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Paper
} from '@mui/material';
import { 
  Storage as StorageIcon,
  Phone as PhoneIcon
} from '@mui/icons-material';
import CallAgentPlans from './components/CallAgentPlans.jsx';
import CallAgentPhoneNumber from './components/CallAgentPhoneNumber.jsx';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentSubscription } from '../../redux/actions/callAgentActions';

// Tab Panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agent-tabpanel-${index}`}
      aria-labelledby={`agent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function CallAgent() {
  const dispatch = useDispatch();
  const { currentSubscription, subscriptionLoading } = useSelector((state) => state.callAgent);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Check if subscription exists, has a plan, and is NOT canceled at period end
  const hasActiveSubscription = !!(
    currentSubscription?.plan?._id && 
    currentSubscription?.cancelAtPeriodEnd !== true
  );

  // useEffect(() => {
  //   dispatch(fetchCurrentSubscription());
  // }, [dispatch]);

  return (
    <Layout>
      <Box sx={{  mt: 3, px: { xs: 0, sm: 2 } }}>
        {/* Header */}
        <Box sx={{ mb: 3, px: { xs: 2, sm: 0 } }}>
          <Typography variant="h5" sx={{ 
            fontWeight: 700, 
            mb: 1,
            fontSize: { xs: '1.5rem', sm: '2rem' },
            color: '#111827'
          }}>
            Call Agent
          </Typography>
          {/* <Typography variant="body2" sx={{ 
            color: '#6b7280',
            fontSize: { xs: '14px', sm: '16px' },
            lineHeight: 1.5
          }}>
            Manage your AI agent's call agent
          </Typography> */}
        </Box>

        {/* Tabs */}
        <Paper sx={{ width: '100%', mb: 2, mx: { xs: 0, sm: 0 } }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              value={tabValue} 
              onChange={handleTabChange}
              aria-label="call agent tabs"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: { xs: '12px', sm: '14px' },
                  minHeight: { xs: '40px', sm: '48px' },
                  px: { xs: 1, sm: 2 },
                  minWidth: { xs: 'auto', sm: 'auto' }
                },
                '& .Mui-selected': {
                  color: '#374151'
                },
                '& .MuiTabs-scrollButtons': {
                  display: { xs: 'flex', sm: 'none' }
                }
              }}
            >
              <Tab 
                icon={<StorageIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />} 
                label="Plans" 
                iconPosition="start"
              />
              <Tab 
                icon={<PhoneIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />} 
                label="Phone Number" 
                iconPosition="start"
                disabled={subscriptionLoading ? true : !hasActiveSubscription}
              />
            </Tabs>
          </Box>
        </Paper>

        {/* Tab Panels */}
        <TabPanel value={tabValue} index={0}>
          <CallAgentPlans />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <CallAgentPhoneNumber />
        </TabPanel>
      </Box>
    </Layout>
  );
}

export default CallAgent;
